(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    

function initRelatedProductsSlider() {
  var $slider = $('.related-products-slider');

  if (!$slider.length) return;

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    rtl: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    adaptiveHeight: false,
    prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="34.016" height="12.493" viewBox="0 0 34.016 12.493"> <path id="Path_241" data-name="Path 241" d="M1,23.257H32.269l-4.515,4.515,1.014,1.014,6.247-6.247-6.247-6.247-1.014,1.014,4.515,4.515H1Z" transform="translate(-1 -16.293)" fill="#76696c"/> </svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="34.016" height="12.493" viewBox="0 0 34.016 12.493"> <path id="Path_465" data-name="Path 465" d="M35.016,23.257H3.746l4.515,4.515L7.247,28.786,1,22.54l6.247-6.247,1.014,1.014L3.746,21.822H35.016Z" transform="translate(-1 -16.293)" fill="#76696c"/> </svg></button>',

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.3
        }
      }
    ]
  });
}

function loadProductRecommendationsIntoSection() {

  var productRecommendationsSection = document.querySelector(".related-products");

  if (!productRecommendationsSection) return;

  var request = new XMLHttpRequest();

  request.open("GET", productRecommendationsSection.dataset.url);

  request.onload = function () {

    if (request.status >= 200 && request.status < 300) {

      var container = document.createElement("div");
      container.innerHTML = request.response;

      var recommendations = container.querySelector(".related-products");

      if (!recommendations) return;

      productRecommendationsSection.innerHTML = recommendations.innerHTML;

   // Initialize Slick AFTER HTML is added
initRelatedProductsSlider();
    }
  };

  request.send();
}

// Theme Editor
document.addEventListener("shopify:section:load", function(event) {

  if (
    document.querySelector(
      '[data-section-id="' + event.detail.sectionId + '"].related-products'
    )
  ) {
    loadProductRecommendationsIntoSection();
  }

});

// Initial Load
document.addEventListener("DOMContentLoaded", function () {
  loadProductRecommendationsIntoSection();
});


  } catch(e) { console.error(e); }
})();
})();
